// Reusable quick-range presets for the Nirvana date picker.
// All ranges resolve to inclusive "YYYY-MM-DD" strings (what the audit/report
// APIs expect). Shared across Activity, Reports, Analytics and future
// content-performance pages.
import {
  format, subDays, startOfMonth, endOfMonth, subMonths,
  startOfQuarter, endOfQuarter,
} from "date-fns";

const f = (d) => format(d, "yyyy-MM-dd");

export const PRESETS = [
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "last7", label: "Last 7 days" },
  { key: "last30", label: "Last 30 days" },
  { key: "thisMonth", label: "This month" },
  { key: "lastMonth", label: "Last month" },
  { key: "thisQuarter", label: "This quarter" },
];

export function computePreset(key, now = new Date()) {
  switch (key) {
    case "today": return { start: f(now), end: f(now) };
    case "yesterday": { const y = subDays(now, 1); return { start: f(y), end: f(y) }; }
    case "last7": return { start: f(subDays(now, 6)), end: f(now) };
    case "last30": return { start: f(subDays(now, 29)), end: f(now) };
    case "thisMonth": return { start: f(startOfMonth(now)), end: f(endOfMonth(now)) };
    case "lastMonth": { const m = subMonths(now, 1); return { start: f(startOfMonth(m)), end: f(endOfMonth(m)) }; }
    case "thisQuarter": return { start: f(startOfQuarter(now)), end: f(endOfQuarter(now)) };
    default: return { start: "", end: "" };
  }
}

// Identify which preset (if any) the current start/end matches; "custom" for a
// manually chosen range, null when empty.
export function matchPreset(start, end) {
  if (!start && !end) return null;
  for (const p of PRESETS) {
    const r = computePreset(p.key);
    if (r.start === start && r.end === end) return p.key;
  }
  return "custom";
}

export function rangeLabel(start, end) {
  if (!start && !end) return "Any date";
  const m = matchPreset(start, end);
  const preset = PRESETS.find((x) => x.key === m);
  if (preset) return preset.label;
  const fmt = (s) => (s ? format(new Date(s + "T00:00:00"), "d MMM yyyy") : "…");
  if (start && end) return start === end ? fmt(start) : `${fmt(start)} – ${fmt(end)}`;
  return start ? `From ${fmt(start)}` : `Until ${fmt(end)}`;
}
